<template>
  <div class="flex" data-cy="math-operations">
    <operation-item
      v-for="mathOperation in MathOperation"
      :key="mathOperation"
      :operation="mathOperation"
      class="mr-2 cursor-pointer rounded-sm bg-disabled p-1 hover:text-primary"
      @click="addOperation(mathOperation)"
    />
    <operation-item
      operation="parenthesis"
      class="mr-2 cursor-pointer rounded-sm bg-disabled p-1 hover:text-primary"
      @click="addOperation([])"
    />
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from "pinia";

import { MathOperation } from "@/enums/customAttributes";
import { useAttributeBuilderStore } from "@/stores/customAttributeBuilder";

import OperationItem from "@/components/customAttributes/OperationItem.vue";

import type { CustomAttributeFormulaItem } from "@/models/customAttributes/customAttribute";

const { currentAttribute } = storeToRefs(useAttributeBuilderStore());

const addOperation = (
  operation: MathOperation | CustomAttributeFormulaItem[]
) => {
  if (!currentAttribute.value?.content?.formula) {
    return;
  }
  currentAttribute.value?.content?.formula.push(operation);
};
</script>
